import { untrack } from 'svelte';

class OverlayStore {
	#count = $state(0);

	get open(): boolean {
		return this.#count > 0;
	}

	/**
	 * Registers an open overlay. Callers acquire from `$effect`, so the counter mutation is
	 * untracked or the effect would depend on the state it writes.
	 * @returns release function; idempotent so an overlay can release on both close and destroy
	 */
	acquire(): () => void {
		untrack(() => (this.#count += 1));
		let released = false;
		return () => {
			if (released) return;
			released = true;
			untrack(() => (this.#count -= 1));
		};
	}
}

export const overlayStore = new OverlayStore();

export const isAnyOverlayOpen = (): boolean => overlayStore.open;
